import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'react-bootstrap';
import { Sprawy } from '../../sprawy/Sprawy';
import Link from '../../../components/Link';
import s from '../../content.scss';
import PaperTile from '../../../components//PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import KartaEuslugi from '../kartaEuslugi/KartaEuslugi';
import { notFoundImageURL } from '../../../config';
import fetch from '../../../core/fetch';
import { connect } from 'react-redux';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import NotFound from '../../notFound/NotFound';
import cloneDeep from 'lodash/cloneDeep';
import find from 'lodash/find';

class szczegolyEuslugi extends React.Component {
  state = {
    colors: 'normal',
    style: {},
    districtEnabled: false,
  };

  componentDidMount() {
    this.setColors();
    this.districtEnabled();
  }

  setColors() {
    const colors = getThemeFromLocalStorage();
    let style = {};
    if (colors !== 'normal') {
      style = {
        color: headerStyle[colors].color,
        backgroundColor: headerStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, style });
  }

  sortUrzedy = (a, b) => {
    const itemA = a.placeOfSettling.toUpperCase();
    const itemB = b.placeOfSettling.toUpperCase();
    if (itemA < itemB) {
      return -1;
    }
    if (itemA > itemB) {
      return 1;
    }
    return 0;
  };

  districtEnabled = () => {
    if (this.props.district && !this.state.districtEnabled) {
      const urzad = find(this.props.districts, urzad => urzad.teryt === parseInt(this.props.district));
      this.setState({ districtEnabled: urzad.showOnList});
    }
  }

  render() {
    let title = null;
    const eserviceData = this.props.eservices[this.props.prefix];
    if (eserviceData) title = eserviceData.title;

    if (eserviceData && eserviceData.shortName === 'OplataZaDzierzaweMiejscaGrzebalnego') {
      title = eserviceData.description;
    }
    let districtEnabled = cloneDeep(this.state.districtEnabled);
    if (!districtEnabled && this.props.district) {
      districtEnabled = find(this.props.districts, urzad => urzad.teryt === parseInt(this.props.district)).showOnList
    }

    let urzad = null;
    if (this.props.district) {
      urzad = find(this.props.districts, urzad => urzad.teryt === parseInt(this.props.district));
    }

    return (
      <div>
        {this.props.district && districtEnabled ?
          <KartaEuslugi
            shortName={this.props.prefix}
            prefix={urzad ? urzad.prefix : null}
            title={title}
            district={this.props.district}
          /> : null}
        {this.props.district && !districtEnabled ?
          <NotFound
            title={''}
          />
         : null}
        {this.props.district ? null : <PaperHeader title="Urzędy lub instytucje udostępniające tę usługę" />}
        {this.props.district ? null :
        <Row>
          {this.props.districts && Object.values(this.props.districts)
            .filter(urzad => urzad.showOnList)
            .filter(urzad => urzad.services.includes(this.props.prefix))
            .sort(this.sortUrzedy)
            .map((urzad, i) => {
              // const start = urzad.teryt === 1020043 ? "eservices" : "eservices";
              const cardUrl = `/euslugi/${this.props.prefix}?district=${urzad.teryt}`;
              return (
                <Col key={i} xs={12} sm={6} md={4}>
                  <PaperTile
                    // href={`/${start}?district=${urzad.teryt}&serviceType=${this.props.prefix}`}
                    href={cardUrl}
                    text={urzad.name}
                    herb={urzad.herb ?
                    `${process.env.OLD_IHUB}/upload/herby/${urzad.herb}`
                  : notFoundImageURL}
                    style={{ fontWeight: 'bold' }}
                  />
                </Col>
              );
            })}
        </Row>
        }
      </div>
    );
  }
}

szczegolyEuslugi.propTypes = {
  prefix: PropTypes.string,
};

const mapState = state => ({
  eservices: state.district.eservices,
  districts: state.district.districts
});

export default withStyles(s)(connect(mapState)(szczegolyEuslugi));



// WEBPACK FOOTER //
// src/routes/euslugi/szczegolyEuslugi/SzczegolyEuslugi.js